import type { ComponentProps } from "react";

import { IconChipItem } from "@similarweb/ui-components";

import { StyledIconChipWrapper } from "./styles";

const FilterIconChip = (props: ComponentProps<typeof IconChipItem>) => {
    return (
        <StyledIconChipWrapper>
            <IconChipItem {...props} />
        </StyledIconChipWrapper>
    );
};

export default FilterIconChip;
